// extracted by mini-css-extract-plugin
export default {"search-container":"SearchPOI_search-container__951Bs","search-input":"SearchPOI_search-input__IDnW9","search-button":"SearchPOI_search-button__550GN"};